module.exports = __webpack_public_path__ + "img/cookie-27595_640.b517b031.png";